// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4T8-M","content":"_2cKIG","ad":"_1TGhK","headline":"_1o6vf","row-1":"WzWbY","row-2":"_3YwyM"};